import Service from '../Service'
import {http} from '../config'

export default class NFSeService extends Service{

    constructor(){
        super('nfse');
    }

    ListarComFiltro(page, pageSize, sortBy, desc, search, columns, filter, include){

        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns);        

        if (filter) {

            let paramTemp = '';
            
            //NUMERO
            if (filter.numeroInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `numero ge ${filter.numeroInicio}`;
            }
            if (filter.numeroFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `numero le ${filter.numeroFim}`;
            }

            //NUMERO RPS
            if (filter.numeroRpsInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `numeroRps ge ${filter.numeroRpsInicio}`;
            }
            if (filter.numeroRpsFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `numeroRps le ${filter.numeroRpsFim}`;
            }

            //DATA EMISSAO
            if (filter.dataEmissaoInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao ge ${filter.dataEmissaoInicio}`;
            }
            if (filter.dataEmissaoFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao le ${filter.dataEmissaoFim}`;
            }
            
            //DOADOR
            if (filter.doadorId){
                paramTemp += `doadorId eq ${filter.doadorId}`;
            }

            //VALOR
            if (filter.valorInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `valor ge ${filter.valorInicio}`;
            }
            if (filter.valorFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `valor le ${filter.valorFim}`;
            }

            //RECEBIVEL
            if (filter.recebivelInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `recebivelId ge ${filter.recebivelInicio}`;
            }
            if (filter.recebivelFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `recebivelId le ${filter.recebivelFim}`;
            }

            //LOTE
            if (filter.loteIdInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `loteId ge ${filter.loteIdInicio}`;
            }

            if (filter.loteIdFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `loteId le ${filter.loteIdFim}`;
            }

            //SITUACAO
            if (filter.situacao){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `situacao eq OngFacil.Domain.Fiscal.EnumSituacaoNFSe'${filter.situacao}'`;
            }

            if (paramTemp) {
                parametros += `&$filter=${paramTemp}`;
            }

        }

        return http.get(`${this._nomeControle}${parametros}`, this.GetHeader(include));
    }

    async Gerar(ids){
        return http.post(`${this.getNomeControle()}/gerar`, ids);
    }

    async Enviar(id){
        return http.post(`${this.getNomeControle()}/enviar/${id}`);
    }

    async EnviarLote(){
        return http.post(`${this.getNomeControle()}/enviarlote`);
    }

    async AtualizarRps(id){
        return http.post(`${this.getNomeControle()}/atualizar/${id}`);
    }

    async AtualizarLote(){
        return http.post(`${this.getNomeControle()}/atualizarlote`);
    }

    EnviarEmail(mesAnoInicial, mesAnoFinal, periodo){
        return http.post(`${this._nomeControle}/enviaremail`, null, {
            params:{
                mesAnoInicial,
                mesAnoFinal,
                periodo
            }
        })
    }

    //INTEGRACAO DFe
    async Transmitir(id){
        return http.post(`${this.getNomeControle()}/${id}/Transmitir`);
    }

    async TransmitirLote(){
        return http.post(`${this.getNomeControle()}/TransmitirLote`);
    }

}
